import { onePlusProducts } from './OnePlusStore';
import './OnePlusStore.css';
import { useNavigate } from 'react-router-dom';

const OnePlusProductList = () => {
  const navigate = useNavigate();

  const handleProductClick = (productModel) => {
    if (productModel === 'OnePlus Nord') {
      navigate('/oneplusstore/products-list/oneplus?series=nord');
    } else if (productModel === 'OnePlus 15S') {
      navigate('/oneplusstore/products-list/oneplus?series=15s');
    } else if (productModel === 'OnePlus 15') {
      navigate('/oneplusstore/products-list/oneplus?series=15');
    } else if (productModel === 'OnePlus Pad') {
      navigate('/oneplusstore/products-list/oneplus?series=pad');
    }
  };

  return (
    <div className="oneplus-product-list">
      <div className="store-title">
        <p className='oneplus-title'>Explore OnePlus</p>
      </div>
      <div className="oneplus-product-list-wrapper">
        {onePlusProducts.map((product) => (
          <div 
            key={product.id} 
            className="oneplus-product-item"
            onClick={() => handleProductClick(product.model)}
            style={{
              cursor:
                product.model === 'OnePlus Nord' ||
                product.model === 'OnePlus 15S' ||
                product.model === 'OnePlus 15' ||
                product.model === 'OnePlus Pad'
                  ? 'pointer'
                  : 'default',
            }}
          >
            <div className="oneplus-product-img-container">
              {product.image ? (
                <img src={product.image} alt={product.model} className="oneplus-product-image" />
              ) : (
                <div className="oneplus-product-icon">{product.model.charAt(0)}</div>
              )}
            </div>
            <div className="oneplus-product-info">
              <h3 className="oneplus-product-title">{product.title}</h3>
              <p className="oneplus-product-description">{product.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnePlusProductList;
